<template lang="pug">
  .closebutton(v-on:click="close")
    svg.closebutton_svg(width="18.17" height="18.17" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.17 18.17")
      polygon.closebutton_path(points="18.17 0.71 17.46 0 9.08 8.38 0.71 0 0 0.71 8.38 9.09 0 17.46 0.71 18.17 9.08 9.79 17.46 18.17 18.17 17.46 9.79 9.09 18.17 0.71")


</template>
<script>
  export default {
    methods: {
      close: function(){
        this.$emit('close');
      }
    }
  }
</script>
<style lang="sass">
  .closebutton
    background-color: #000
    display: flex
    justify-content: center
    align-items: center
    transition: background-color .1s linear
    width: 100%
    height: 100%
    cursor: pointer
    &:hover
      background-color: #F0DC00
      .closebutton
        &_path
          fill: #000
    &_svg
    &_path
      transition: fill .1s linear
      fill: #fff
</style>